/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Link, LinkHighlight, Text } from '@sonarsource/echoes-react';
import { FormattedMessage } from 'react-intl';
import { SharedDocLink, useSharedDocUrl } from '~adapters/helpers/docs';

interface OrganizationJiraIntroProps {
  isConnected: boolean;
  sonarOrganizationName?: string;
}

export function OrganizationJiraIntro({
  isConnected,
  sonarOrganizationName,
}: Readonly<OrganizationJiraIntroProps>) {
  const docUrl = useSharedDocUrl();

  const text = isConnected
    ? 'organization.jira.binding.connected.intro'
    : 'organization.jira.binding.not_connected.intro';

  return (
    <Text as="div" className="sw-flex sw-flex-col sw-gap-4">
      <FormattedMessage
        id={text}
        values={{
          b: (text) => <b>{text}</b>,
          organization: <span className="fs-mask">{sonarOrganizationName}</span>,
          organizationBindingDocLink: (text) => (
            <Link highlight={LinkHighlight.Default} to={docUrl(SharedDocLink.JiraIntegration)}>
              {text}
            </Link>
          ),
          p: (text) => <p>{text}</p>,
          projectBindingDocLink: (text) => (
            <Link
              highlight={LinkHighlight.Default}
              to={docUrl(SharedDocLink.JiraIntegrationProjectBinding)}
            >
              {text}
            </Link>
          ),
          setupGuideDocLink: (text) => (
            <Link
              enableOpenInNewTab
              highlight={LinkHighlight.Accent}
              to={docUrl(SharedDocLink.JiraIntegration)}
            >
              {text}
            </Link>
          ),
          troubleshootingDocLink: (text) => (
            <Link
              highlight={LinkHighlight.Default}
              to={docUrl(SharedDocLink.JiraIntegrationTroubleshooting)}
            >
              {text}
            </Link>
          ),
        }}
      />
    </Text>
  );
}
